/* eslint-disable quotes */
// Turco
export const turco = {
  start: "Başla",
  save: "Save",
  delete: "Sil",
  update: "Güncelle",
  lets: "Hadi oynayalım",
  permanentbuy: "Kalıcı olarak satınal",
  signature: "Aylık İmza",
  signatureano: "Yıllık Abonelik",
  male: "Eril  ",
  female: "kadınsı",
  ambos: "Her ikisi de",
  inicio9: "Yardım",
  choosecategory: "Kategoriyi Seç",
  categories: "Kategoriler",
  light: "Hafif",
  preliminary: "Ön Hazırlık",
  oral: "Sözlü seks",
  anal: "Anal seks",
  hot: "Sıcak",
  extreme: "Aşırı",
  vd: "Doğruluk ?",
  dare: "Meydan okumak ?",
  truth: "Doğruluk",
  time: "Zaman",
  createMyChallenges: "Kendi meydan okumanızı",
  chosen: "Seçilmiş",
  text3: "Bırakın içinizde sevgi aksın!",
  text4: "Yoğun yaşamaya hazır olun",
  close: "Kapat",
  dev: "Tarafından geliştirilmiştir Dev12BR",
  next: "SONRAKİ",
  config3: "Reklam yok",
  config4: "Geliştirmek için avatarları seçin",
  config9: "Kendi meydan okumalarınızı oluşturun",
  config10: "Özel kategori",
  config11: "800'den fazla yeni meydan okuma",
  version: "Premium Sürüm",
  alert3: "En az bir kategori seçin",
  tituloAlert1: "⚠️ Oyun başlamak üzere 😜",
  description: "Merhaba, benim sorum veya önerim şu:",
  contact: "İletişim",
  botaoApple: "Satın alımları geri yükle",
  alertCompra: "Satın alma işleminiz geri yükleniyor",
  NotPurchase: "Satın alma işleminiz yok",
  options: "Seçenekler",
  avalie: "Uygulamayı Değerlendirin",
  novaCategoria: "Benim kategorilerim",
  alterLanguage: "Dil Değiştir ?",
  textLanguage: "Dili değiştirirken uygulama yeniden başlayacaktır",
  textLanguage1: "Dil Değiştir",
  cancel: "İptal",
  languages: "Dil Ayarları",
  deletCat: "Kategoriyi sil",
  duvidas: "Sorular veya Öneriler - Spicy Challenges",
  textDeletCat:
    "Bu kategoride bulunan meydan okumalar, bu kategori silinirken silinecektir. Bu eylemden sonra artık geri alınamaz..",
  deletDes: "Meydan okumayı sil",
  textDeletDes: "Meydan okuma silindikten sonra bu işlem artık geri alınamaz.",
  desafio: "Yeni Meydan Okumayı Kaydet",
  desafiotexto: "Meydan okuma",
  textoeditDesafio: "Bunu kim yapabilir?",
  textEmquem: "Kim ?",
  nome: "İsim",
  inicio: "Oyunu başlat",
  cadastrarCategory: "Yeni Kategori Ekle",
  inicio15: "Yeni bir kategori oluşturuluyor",
  inicio16:
    "Adım 1 : Bu ekranın altında bulunan + işaretli düğmeye basın. Tuşa bastıktan sonra yeni kategorinizi girmeniz için bir pencere açılacaktır.",
  inicio17: `Adım 2: Yeni kategorinizi girin ve kaydet'e tıklayın`,
  inicio18:
    "Adım 3: Bu kategoriyi düzenlemek veya kategori içindeki zorlukları EKLEMEK için üzerine tıklayın.",
  inicio19:
    "Adım 4: Bir sonraki ekranda, ⬆️ ok ile gösterilen düğmeye basıldığında yeni kategorinizi düzenlemek için bir pencere açılacaktır.",
  inicio20:
    "Adım 5: Bir sonraki ekranda, ⬆️ oku ile gösterilen düğmeye basarak kategoriyi sileceksiniz.",
  inicio21:
    "Adım 1: Bu kategoriye yeni bir meydan okuma eklemek için aşağıdaki düğmeye basın",
  inicio22: "Yeni bir meydan okuma yaratmak",
  inicio23:
    "Adım 2: Kaydın her bir alanını ayrıntılı olarak öğrenmek için daire içine alınmış her bir öğeye tıklayın",
  inicio24: "Meydan okuma metni",
  inicio25: `Meydan okumayı istediğiniz gibi yazın ve oyuncunun adının meydan okumada görüntülenmesi için aşağıdaki kırmızı düğmeye basmanız yeterlidir. 
    
Aşağıdaki karakterleri ekleyecektir {nome}. 

** BU KARAKTERLERİ DEĞİŞTİRMEYİN ** Çünkü adın uygun şekilde görüntülenmesi için aşağıda açıklandığı gibi olması gerekir ⬇️⬇️⬇️⬇️⬇️⬇️

Meydan okuma: Boynunu öp {nome}`,
  inicio26: "Kim yapabilir ve kim alabilir?",
  inicio27: `Eğer meydan okuma "her iki" cinsiyetten katılımcılar tarafından gerçekleştirilebiliyor ve alınabiliyorsa "Her ikisi" seçeneğini seçin.
  
Eğer meydan okuma bir türe yönelikse, sadece istediğiniz türü seçin.
`,
  inicio28: "Mücadeleye zaman ekleme",
  inicio29:
    'Mücadelenizin bir zamanı varsa, aşağıdaki "aralığı" sürüklemeniz yeterlidir; değer yukarıda görüntülenecektir. Mücadelede süre dolduktan sonra, mücadelenin bittiğini bildirmek için bir ses çalacaktır.',
  aviso12: `burada sadece kategori oluşturursunuz!
    
Zorlukları eklemek için yeni oluşturulan kategorinizin düğmesine basmanız yeterlidir ⬆️⬆️⬆️⬆️⬆️⬆️`,
  voltar: "Geri Dön",
  semDe: "Meydan okumalar olmayan oyuncu",
  semDe2: `Bu oyuncu için en az bir meydan okuma kaydedin 😬. 
  
Giriş ekranına yönlendirileceksiniz.`,
  term: "Gizlilik Politikası",
  Potitic: "Kullanım Koşulları",
  adquirited: "Satın alınan",
  camera: "Kamera",
  galery: "Galeri",
  avatar: "Avatarlar",
  image: "Resim",
  seletion: " Seçilen",
  editCategory: "Kategoriyi Düzenle",
  frase1: "Meydan okumalardan zevk alıyor musunuz ?",
  frase2: "Premium Meydan Okumaları denemeye ne dersiniz?",
  send: "Gönder",
  errTexto:
    "Bir çeviri hatası bulduysanız, lütfen aşağıdaki alandaki cümleyi düzeltin:",
  errTitulo: "Bir sorun mu fark ettiniz?",
  errCorrect: "Türkçe nasıl olurdu?",
  thisLanguageIsCorrect: "TürKÇE görevi doğru mu?",
  yes: "Evet",
  no: "Hayır",
  errSend: "Öneri gönder",

  share: "Paylaş",
  fraseShare: `Ne kadar iyi bir uygulama! Sizin de beğeneceğinizi bildiğim için paylaşıyorum!
  İndirin ve çok iyi değilse söyleyin lol...😉
  
  
  İndirmek için bağlantı: https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇹🇷",
  morePlayer: "Daha fazla oyuncu ile oynamak?",
  players: "Oyuncular",
  carregar: "Resim Yükle",
  takePhoto: "Bir resim çekin veya bir resim seçin",
  useAvatar: "Veya Avatarları kullanın",

  hetero: "Düz Çift",
  gay: "Gay Çift",
  lesbico: "Lezbiyen Çift",

  nomeHomem1: "Adamın Adı",
  nomeHomem2: "Adamın Adı",
  nomeMulher1: "Kadın Adı",
  nomeMulher2: "Kadın Adı",
  messageErr: "Oyuncuları ekle 🙌",
  descricaoErr: "Katılımcıların adlarını girin ✍️",
  why: "Bize nedenini söyleyin...",
  later: "Daha Sonra Değerlendir",
  txtCard1: "Senin sıran 🔥",
  txtCard2: "Bunu gerçekleştir 😘",
  txtCard3: "Hadi ama! 😜",
  txtCard4: "Sonraki meydan okuma 😈",
  txtCard5: "Bir tane daha! 👄",

  tituloBloco1Novo: "Partnerinizle Cinsel Yakınlığı Keşfedin",
  subtitulo1Novo: "1 milyondan fazla mutlu çift",
  texto1Novo:
    "Partnerinizle aranızdaki yakınlığı keşfedin ve çiftler için en eğlenceli oyunlara ulaşın! Aşk bağınızı güçlendirmek için özel olarak tasarlanmış oyunların kilidini şimdi açın!",

  tituloBloco2Novo: "Yeni deneyimler ve daha iyi bir ilişki",
  texto2Novo1: `1500+ meydan okuma sizi bekliyor`,
  texto2Novo2: "Kendi meydan okumalarınızı yaratın",
  texto2Novo3: "Özel kategoriler",
  texto2Novo4: "Reklamlar yok",
  texto2Novo5: "Özel avatarlar",
  texto2Novo6: "Her gün yeni meydan okumalar",
  texto2Novo7: "Düzenli olarak güncellenen oyunlar",
  tituloBloco3Novo: "Kategorinin en yüksek puanı",
  tituloBloco4Novo: "İlişkiniz için faydaları:",
  texto4Novo1: "Yakınlık",
  texto4Novo2: "Tutku",
  texto4Novo3: "Hafiflik",
  texto4Novo4: "Çekim",
  texto4Novo5: "Bağ",
  texto4Novo6: "Zevk",

  tituloBloco5Novo: "Çiftler ne diyor",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1: `Bence bu şimdiye kadar mobil cihazlarda bulduğum en iyi uygulama, erotik ve ilginç olarak gördüğüm diğer tüm uygulamalar ile karşılaştırılamaz, bu yüzden bir iş bul ve bunu satın al. Meteliksiz olduğun için şikayet etme. Burada gerçekten iyi şeyleri kaçırıyorsunuz ve tüm uygulamaya sahip olmak sadece10.00 $. Yerel zevk mağazalarında aldığınız oyunlardan daha iyi deneyimler sunuyor.`,
  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "Bu uygulama inanılmaz! İndirip indirmeme konusunda şüpheye düşmüştüm ama kesinlikle son zamanlarda yaşadığımız en iyi duyguydu. Hala birçok şeyi birlikte yapabileceğimizi bilmek ne kadar güzel. 🤭 Ücretli sürümü test ettik ve gerçekten buna değer, henüz o zevk seviyesine ulaşmamıştık.",
  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "İlişkinizi renklendirmek istiyorsanız bu uygulama mükemmel! Diğerlerini zaten test etmiştim ama hiçbiri bizi bunun kadar memnun etmedi. Ön sevişmemiz çok daha sıcak ve zevkliydi (şimdi gerisini hayal edin!) Ücretli sürümü satın almaya gerçekten değer (daha yoğun bir zevk hissetmek istiyorsanız) ama ücretsiz sürüm de sizi şaşırttı.",
  texto5depoimentoTitulo4: "Anne owens",
  texto5depoimento4:
    "Mükemmel! Gerçekten çok iyiydi... Oyun sırasında çok azdık, bu da seksi çok daha sürükleyici hale getirdi, her yerde zevk vardı! Şimdiden tekrar oynamak için sabırsızlanıyoruz 💦🔥 azgınlığı kaldırabilirseniz ücretli sürümü de tavsiye ediyoruz 🤤",

  tituloBloco6Novo:
    "Dünyanın dört bir yanındaki yüzlerce çift gibi yapın ve ilişkinizi renklendirin. 800'den fazla yeni meydan okumayı keşfedin!",
  texto6Select: "Sürümü seçin:",
  texto6Premium: "Premium",
  texto6Assinatura: "Abonelik ",
  texto6Mensal: "Aylık",
  texto6Anual: "Yıllık ",
  texto6Vitalicia: "Ömür boyu lisans",
  bePremium: "Premium Üye Ol",
  buyNew: "Satın Al",
  attention: "Dikkat!",
  changeGender: "Cinsel yöneliminizi değiştirdiniz",

  tituloAvaliacao: "Oyunu beğeniyor musunuz?",
  textoAvaliacao: "Değerlendirin ve bize geliştirmemizde yardımcı olun!",
  agoraNão: "Şimdi değil",
  enviarAvaliacao: "Gönder",

  nomeJogo1: "Tutkulu Görevler",
  nomeJogo2: "Doğru? Cesaret?",
  nomeJogo3: "Mizah Seviyesi",
  nomeJogo4: "Yaramaz Rulet",
  nomeJogo5: "Günün Sözü",
  naughtyQuiz: "Yaramaz Test",

  playAlone: "Yalnız Oyna",
  estaSozinho: "Yalnız mısın?",
  selectPlayer: "Oyuncu seçin",

  skip: "Atla",
  responder: "Gönder",
  respondaAqui: "Buraya cevap ver",
  config4: "Özelleştirmek için avatar seçin",

  tituloSelect1: "Yalnız oynamak mı?",
  tituloSelect2: "Tehlikeli soruları yanıtla!",

  subTituloSelect1: "Sana yardım ediyoruz!",
  subTituloSelect2: "Ne kadar yaramaz olduğunuzu keşfedin!",
  txtJogador1:
    "Oyuncunuzu seçin ve yalnızca sizin için tasarlanmış rehberli solo zevkleri keşfedin!",
  txtJogador2: "Seçilen oyuncu soruları yanıtlayacak",
  tituloCena: "HANGİ ÖĞELERİ KULLANMAK İSTERSİNİZ?",
  subTituloCena: `Bazıları yok mu? "Al" a dokunun ve iş ortağı mağazadan satın alın.`,
  play: "Oyna",

  titleUserWarning: "Bir kullanıcı seç",
  txtUserWarning: "Soruları yanıtlamak için bir kullanıcı seç",
  shareNivelDeSafadeza:
    "Hey, yaramazlık seviyemi kontrol et 😈 Yoğun haz anlarını yaşa. Sen de 💋 Şimdi uygulamayı indir ve partnerinle sıcak zorlukları 🔥 denemeye hazır ol: ➡️ https://acizteklifleruygulamasi.page.link/sharelevelhot",

  shareDica:
    "Aşk hayatını şimdi değiştir! Uygulamayı indir ve ateşli bir ilişkinin sırrını keşfet: ➡️ https://acizteklifleruygulamasi.page.link/tipoftheday",

  resultadoQuiz1:
    "Sen örtülü bir kişiliğe sahipsin, cinsellikten pek hoşlanmıyorsun, romantik bir şeyleri tercih edersin!",
  resultadoQuiz2:
    "Aşırı romantiksin ve cinselliği fazla kullanmaktansa mum ışığında bir atmosferi tercih edersin.",
  resultadoQuiz3: "Oldukça özel ve mahrem şeyleri gizli tutmaya inanansın.",
  resultadoQuiz4:
    "Bu, bazen cinsel olmadığınız anlamına gelmez, ancak bu ateşi özel biriyle harcamayı tercih edersiniz.",
  resultadoQuiz5:
    "Sıcaklığınız arka planda olabilir, ancak sıcaklık olduğu gerçeğini değiştirmez!",
  resultadoQuiz6:
    "Yeni deneyimler keşfetmekten hoşlanırsınız, ancak her zaman saygı ve onayla.",
  resultadoQuiz7:
    "Sıcak buluşmaları, öpüşmelerle dolu buluşmaları çok seversin. Ancak, filminizi izlerken ya da mum ışığında romantik bir akşam yemeği yerken sakin bir tarafınız da vardır.",
  resultadoQuiz8:
    "Yeni ve heyecanlı şeyleri denemeye isteklisiniz, ancak her zaman sorumlulukla.",
  resultadoQuiz9:
    "Cesur bir insansınız ve özel yaşamınızı ara sıra hareketlendirmekten hoşlanırsınız.",
  resultadoQuiz10:
    "Hayattan tüm zevkleri çıkarmaktan hoşlanırsınız ve cinsellik konusunda sınırlama yapmazsınız.",
  resultadoQuiz11:
    "Sizle kötü zaman olmaz, her zaman hızlı bir şeyler yapma zamanıdır! Romantik film mi? Sadece 50 Ton Gri!",
  resultadoQuiz12:
    "Sizler için mahremiyet sürekli bir maceradır ve risk almak konusunda korkunuz yoktur.",
  mes: "Ay",
  desafiosRestantesDois: "2 Premium meydan okumanız kaldı!",
  nenhumDesafioRestante: "Hiç Premium meydan okuma kalmadı!",
  tornePremiumAviso1:
    "Şimdi premium olun ve 1000 özel meydan okumadan yararlanın!",
  tornePremiumAviso2:
    "Sınırsız meydan okumaların, özel içeriklerin ve kesintisiz eğlencenin keyfini çıkarın!",
  conteudoPremium: "Özel içerik seçtiniz!",
  aproveite4desafios:
    "Özel bir zevk denemek için 4 premium meydan okumadan yararlanın.",
  calculando: "Sonuçlar hesaplanıyor...",
  nivelRomantismo: "Romantizm seviyeniz...",
  finalizar: "Bitir",
  erroQuizTitulo: "Cevabınızı girin",
  erroQuizFrase: "Devam etmek için cevabınızı girin!",
  new: "YENİ Özellikler",

  //resposta quiz safadeza

  resQuiz1: "Nazik",
  resQuiz2: "Aşk dolu",
  resQuiz3: "Büyüleyici",
  resQuiz4: "Süper yaramaz",

  texto6Semanal: "Haftalık",
  weekly: "Haftalık İmza",

  tempSemanal: "Haftalık faturalandırma",
  tempMensal: "Aylık faturalandırma",
  tempAnual: "Yıllık faturalandırma",
  tempSempre: "Tek seferlik ödeme",
  canceleAny: "Her zaman iptal et",

  //Tela do safadrometro
  Low: "Düşük",
  Medium: "Orta",
  High: "Yüksek",

  lifeTime: "Ömür boyu erişim",
  notNow: "Şimdi değil, teşekkürler",
  match: "YAPAY ZEKAYLA EŞLEŞTİR",

  dateTitle: "Yeni uygulamamızı görmek ister misiniz?",

  dateBody:
    "Yaramaz 😈 botlarla sohbet etmek ve flört etmeyi pratik yapmak ister misiniz? Eğleneceksiniz! 🔥",
  goToDate: "Date.AI'yi Şimdi Deneyin!",
  goodForU: "SENİN İÇİN İYİ MİYDİ?",
  rateOurPerformance: "Şimdiye kadar performansımızı değerlendirin",
  veryGood: "Çok İyi",
  veryBad: "Çok Kötü",
  feedbackChallenge: `Hot Challenges uygulamasını diğer çiftlerle paylaşmanızı sağlayacak şey ne olurdu ve neden?`,
  type: "Cevabınızı buraya yazın...",
  survey: "Memnuniyet anketi.",
  shareIfConfortable:
    "Rahat hissediyorsan, arkadaşlarınla paylaşmaktan çekinme :)",

  howToPlay: "Nasıl Oynanır",
  howToPlayHotChallenge:
    "İşleri ateşlemeye hazır mısın? Bir meydan okuma kartı çek ve partnerini ateşli bir hareketle şaşırt!",

  preGameTip1:
    "Arzularınızı serbest bırakın ve partnerinizle unutulmaz anlar yaşayın!",
  preGameTip2: "Tutkularınızı ateşleyin ve birlikte unutulmaz anlar yaratın!",
  preGameTip3:
    "En vahşi arzularınızı keşfedin ve asla unutamayacağınız anılar yaratın!",
  preGameTip4:
    "Fantazilerinizi serbest bırakın ve saf zevk dolu anların tadını çıkarın!",
  selecionajoagador: `Oyun zamanı`,
  dica: "İpucu",

  howToPlayNaughty:
    "En sevdiğiniz oyuncakları ve nesneleri seçin. Çarkı çevirin ve kader bir sonraki yaramaz meydan okumanızı belirlesin!",
  howToPlayTruthOrDare:
    "Kaderini seç: bir gerçeği paylaş ya da cesur bir meydan okumayı kabul et. Eğlence başlasın!",

  howToKama1: "Zevk Pozisyonlarını Keşfedin – 365 Gün Tutku!",
  howToKama2:
    "Rastgele bir kart seçin, pozisyonu deneyin ve birlikte zevkin yeni zirvelerini keşfedin!",

  kamaExplain:
    "Her gün yeni bir pozisyonun kilidini açın ve tutkunuzun nihai koleksiyonunu oluşturun – 365 gün sürecek unutulmaz bir zevk yolculuğu burada başlıyor!",
  howToDo: "Nasıl yapılır",
  pergunta: "Soru",
  restart: "Yeniden Başlat",
  dialogText1HotChallenges:
    "Seçilen kategorilerle mevcut olan tüm meydan okumaları tamamladınız.",
  dialogText2HotChallenges:
    "Daha fazla kategori seçin veya mevcut meydan okumalarla oyunu yeniden başlatın!",
  noChallenges: "Meydan Okuma Yok!",

  objects: "Nesneler",
  dialogText1NaughtyGames:
    "Seçilen nesneler ile tüm mevcut meydan okumaları tamamladınız.",
  dialogText2NaughtyGames:
    "Daha fazla nesne seçin veya mevcut meydan okumalarla oyunu yeniden başlatın!",
  unlockPremium: "Premium Kilidini Aç",
  noCategory: "Başlamak için lütfen en az bir kategori seçin.",
  thanksForFeedback:
    "Deneyimi iyileştirmemize yardımcı olduğunuz için teşekkürler!",
  categoryKamasutra: "Tutkunu seç ve oyna!",
  tap: "Pozisyonunu ortaya çıkarmak için dokun!",
  step: "Adım Adım Rehber",
  shareQuizButton: "Yaramazlık seviyeni paylaş!",
  tryAgain: "Tekrar dene",
  unlockAllFun: "Tüm eğlenceyi keşfet",
  limitedOffer: "Sınırlı süreli özel teklif!",
  fill: "Kendi adınızı ve partnerinizin adını girin.",

  kamaNotificationTitle: "🔥 Yeni kartınız açıldı!",
  kamaNotificationBody:
    "{variavel}. gün pozisyonunuz hazır. Bugün yeni bir şey denemeye ne dersiniz? 💋",

  titleNewGame: "Roleplay’e Hazır Olun!",
  phraseNewGame:
    "Bir sonraki güncellemede, en yaratıcı fantezilerinizi keşfetmek için yeni bir oyun geliyor. Karakterleri seçin, hikayeler oluşturun ve partnerinizle eğlenceyi yeni bir seviyeye taşıyın. 🔥",
  awaitNewGame: "Bekleyin ve benzersiz anlar yaşamaya hazırlanın!",

  selectObjects:
    "Oyununuzu kişiselleştirmek için iki veya daha fazla öğe seçin. En iyi şekilde keşfedin.",
  soon: "Yakında",
  wantToBeNotify: "Bildirilmek istiyorum.",
  ok: "Tamam",
  vezDe: "DÖNÜŞ",

  categoryLabel: "Kategori",
  descriptionLabel: "Açıklama",

  loginConnect: "Giriş yap",
  loginNoAccount: "Hesabınız yok mu?",
  loginCreateNow: "Şimdi oluştur",
  loginOrConnect: "veya bağlan",

  email: "E-posta",
  password: "Şifre",
  loginRegister: "Kayıt ol",
  loginAlreadyHas: "Zaten hesabınız var mı?",
  enterNow: "Şimdi Giriş Yap",

  logout: "Çıkış Yap",
  customerPortal: "Müşteri Portalı",
  installApp: "Uygulamayı Yükle",

  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/turco.mp4",
};
